import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { TokenService } from './token.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SocketService {

  private socket!: Socket;
  private isConnected = false;
  private readonly SocketURL = environment.socketUrl;

  constructor(private token: TokenService) { }

  connect() {

    if (this.isConnected) return;

    const user = this.token.user;
    if (!user?.userId) return;

    this.socket = io(this.SocketURL + '/user', {
      auth: {
        userId: user.userId
      },
      transports: ['websocket']
    });

    this.socket.on('connect', () => {
      this.isConnected = true;
      // console.log('✅ Socket connected:', this.socket.id);
    });

    this.socket.on('disconnect', () => {
      this.isConnected = false;
      // console.log('❌ Socket disconnected');
    });
  }


  /* listen diagnostic result */
  onDiagnosticUpdate(callback: (data: any) => void) {
    if (!this.socket) return;


    this.socket.off('diagnostic:update');
    this.socket.on('diagnostic:update', callback);
  }
  /* DEVICE REALTIME LOCATION */
onDeviceUpdate(callback: (data: any) => void) {
  this.socket.on('device:update', callback);

}

offDeviceUpdate(callback: (data: any) => void) {
  if (!this.socket) return;
  this.socket.off('device:update', callback);
}

  /* NEW TEST STARTED */
  onTestNew(callback: (data: any) => void) {

    if (!this.socket) return;
    this.socket.off('test:new');
    this.socket.on('test:new', callback);
  }

  /* TEST RESULT */
  onTestUpdate(callback: (data: any) => void) {


    if (!this.socket) return;
    this.socket.off('test:update');
    this.socket.on('test:update', callback);
  }


  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.isConnected = false;
    }
  }
}
